import { ActionTypes } from './types';
import { ThunkResult } from '../../types';

export const hotspotQuestionAnswer = (data: any, questionId: string): ThunkResult => dispatch => {
  dispatch({
    type: ActionTypes.HOTSPOT_QUESTION_ANSWER,
    payload: { data, questionId }
  });
};
